import { GitMergeIcon } from "lucide-react";

export function Logo() {
  return (
    <div className="bg-primary text-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
      <GitMergeIcon className="size-5" />
    </div>
  );
}
